import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { LAUNCH_DARKLY_CLIENT_SIDE_ID } from '#src/config.ts';

export const withFFProvider = () =>
  withLDProvider({
    clientSideID: LAUNCH_DARKLY_CLIENT_SIDE_ID,
    options: {
      sendEventsOnlyForVariation: true,
    },
    context: {
      kind: 'user',
      key: '00000000-0000-0000-0000-000000000000',
    },
  });
